import React from "react";
import { Scope } from "informed";

import { Font } from "../";

const Title = () => {
	return (
		<Scope scope="title">
			<div className="theme-columns">
				<div className="theme-column">
					<h4 className="header">Title</h4>
					<div className="theme-content" style={{ marginTop: "10px" }}>
						<Font state="navigation-title" hideFieldRowBorder={true} />
					</div>
				</div>
			</div>
		</Scope>
	);
};

export default Title;
